import React from 'react';
import PropTypes from 'prop-types';
import { RadioButtonLabel } from './RadioButton.style';
import { ABUtils } from '../../utils';

export const RadioButton = ({ id, checked, children, onChange }) => {
    const { isCssVariationMobile } = ABUtils.getABs();
    return (
        <React.Fragment>
            {isCssVariationMobile && (
                <React.Fragment>
                    <input
                        id={id}
                        type="radio"
                        checked={checked}
                        readOnly
                        className="prisma-selectable-native"
                        onChange={onChange}
                    />
                    <RadioButtonLabel className="prisma-selectable-content" htmlFor={id}>
                        <span className="prisma-selectable-input prisma-radio-back">
                            <span className="prisma-selectable-fill prisma-radio-fill"><span className="odf-icon odf-icon-tick" /></span>
                        </span>
                        {children}
                    </RadioButtonLabel>
                </React.Fragment>
            )}
            {!isCssVariationMobile && (
                <RadioButtonLabel className="odf-selectable-content" htmlFor={id}>
                    <div className="odf-flex-container-row odf-flex-container-nogutter">
                        <div className="odf-flex-item">
                            <input
                                id={id}
                                type="radio"
                                checked={checked}
                                readOnly
                                className="odf-selectable-native"
                                onChange={onChange}
                            />
                            <span className="odf-selectable-input odf-radio-back">
                                <span className="odf-selectable-fill odf-radio-fill" />
                            </span>
                        </div>
                        <div className="odf-flex-item odf-space-outer-left-s">{children}</div>
                    </div>
                </RadioButtonLabel>
            )}
        </React.Fragment>
    );
};

RadioButton.propTypes = {
    id: PropTypes.string.isRequired,
    checked: PropTypes.bool,
    children: PropTypes.node,
    onChange: PropTypes.func.isRequired,
};

RadioButton.defaultProps = {
    checked: false,
    children: null,
};
